import { ICenterItem } from "./models";

interface IProps {
    item: ICenterItem,
    onSelect: (id: number) => void
}

const Center = (props: IProps) => {
    const handleCenterSelect = () => {
        props.onSelect(props.item.center.id);
    };

    return (
        <div className='col-xs-6 col-sm-2'>
            <div className="checkbox" style={{ margin: 0, padding: 1 }}>
                <label>
                    <input type="checkbox" value={props.item.center.id} checked={props.item.selected} onChange={handleCenterSelect} />
                    {props.item.center.alias}
                </label>
            </div>
        </div>
    );
}

export default Center;